import { createMemoryKeyValueStorage } from './createMemoryKeyValueStorage';
import { KeyValueStorage } from './KeyValueStorage';

export type PersistentKeyValueLocalStorageConfig = {
  fallbackStorageFactory?: () => KeyValueStorage;
};

export function createPersistentKeyValueLocalStorage({
  fallbackStorageFactory = createMemoryKeyValueStorage,
}: PersistentKeyValueLocalStorageConfig = {}): KeyValueStorage {
  const fallbackStorage = fallbackStorageFactory();

  function setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      localStorage.removeItem(key);
      fallbackStorage.setItem(key, value);
    }
  }

  function getItem(key: string): string | undefined {
    return localStorage.getItem(key) ?? fallbackStorage.getItem(key);
  }

  function removeItem(key: string): void {
    localStorage.removeItem(key);
    fallbackStorage.removeItem(key);
  }

  function clear(): void {
    localStorage.clear();
    fallbackStorage.clear();
  }

  return {
    setItem,
    getItem,
    removeItem,
    clear,
  };
}
